module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAeAQMAAADn1/elAAAABlBMVEVHcExfY2j1czzSAAAAAXRSTlMAQObYZgAAACFJREFUCNdj+P///wMGMHGAgSEBiTh+wA5KoEnQThbuFgCPoTTd0jSkxAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/mobileb/ic_Movies&TV.png
// module id = +TtI
// module chunks = 1